import axios from 'axios'
import OptionsTransformer from 'transformers/OptionsTransformer'

export default {
    getList() {
        return axios.get('unauthenticated/user-roles', {
            transformResponse: [OptionsTransformer.transform('id', 'name')],
        })
    },
}
